import { Component, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import {DisciplineService} from '../../services/discipline.service';
import {AuthentificationService} from '../../../core/services/authentification.service';
import {ExDiscipline} from '../../../class/ex/ExDiscipline';
import {SelectionModel} from '@angular/cdk/collections';
import {Discipline} from '../../../interface/api/Discipline';
import {TranslationService} from '../../services/translation.service';
import { NgClass } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-disciplines-v2',
    templateUrl: './disciplines-v2.component.html',
    styleUrls: ['./disciplines-v2.component.scss'],
    providers: [DisciplineService],
    imports: [NgClass, MatIcon, TranslateModule]
})
export class DisciplinesV2Component implements OnInit {
    private _disciplineService = inject(DisciplineService);
    auth = inject(AuthentificationService);
    translationService = inject(TranslationService);



    @Input() set initialSelection(array: Discipline[]) {
        this._initialSelection = array;
        this.updateSelection();
    }

    @Input() max = 5;
    @Input() required = true;

    @Output() disciplinesHasChanged: EventEmitter<Discipline[]> = new EventEmitter();

    public allDisciplines: Discipline[] = [];
    public disciplinesSelection: SelectionModel<Discipline>;

    protected _initialSelection: Discipline[] = [];

    constructor() {
        this.disciplinesSelection = new SelectionModel<Discipline>(true, [], true);
        this.disciplinesSelection.changed.subscribe(
            ev => {
                this.disciplinesHasChanged.emit(
                    ev.source.selected
                );
            }
        );
    }

    ngOnInit() {
        this._disciplineService
            .getDisciplines(false)
            .subscribe((res: ExDiscipline[]) => {
                if (res) {
                    this.allDisciplines = res;
                    this.updateSelection();
                }
            });
    }

    public filterChildren(children) {
        return children.filter(child => child.enabled === true);
    }

    private updateSelection(): void {
        this.allDisciplines.forEach(firstLevelItem => {
            this.selectIfMatch(firstLevelItem);

            firstLevelItem.children?.forEach(
                item => this.selectIfMatch(item)
            );
        });
    }

    private selectIfMatch(item: Discipline): void {
        if (this._initialSelection.some(initialItem => initialItem.id === item.id)) {
            this.disciplinesSelection.select(item);
        }
    }

    toggleSelection(discipline: Discipline): void {
        if(this.disciplinesSelection.isSelected(discipline)){
            this.disciplinesSelection.deselect(discipline);
            return;
        }

        if(this.disciplinesSelection.selected.length >= this.max){
            return;
        }

        this.disciplinesSelection.select(discipline);
    }
}
